/**
 * Canonical Unify StructureDefinition (profile) URLs.
 *
 * Single source of truth for the `meta.profile` values the app stamps and the
 * server validates against. Convention:
 *   https://unify.health/fhir/StructureDefinition/Unify<ResourceType>[<Subtype>]
 */

export const UNIFY_PROFILE_BASE = 'https://unify.health/fhir/StructureDefinition';

/** Prefix that identifies a Unify-owned resource profile (used when replacing stale profiles). */
export const UNIFY_PROFILE_PREFIX = `${UNIFY_PROFILE_BASE}/Unify`;

export const UNIFY_PROFILES = {
  // P0
  appointment: `${UNIFY_PROFILE_BASE}/UnifyAppointment`,
  questionnaireResponse: `${UNIFY_PROFILE_BASE}/UnifyQuestionnaireResponse`,
  serviceRequest: `${UNIFY_PROFILE_BASE}/UnifyServiceRequest`,
  episodeOfCare: `${UNIFY_PROFILE_BASE}/UnifyEpisodeOfCare`,
  task: `${UNIFY_PROFILE_BASE}/UnifyTask`,

  // P1
  patient: `${UNIFY_PROFILE_BASE}/UnifyPatient`,
  practitioner: `${UNIFY_PROFILE_BASE}/UnifyPractitioner`,
  relatedPerson: `${UNIFY_PROFILE_BASE}/UnifyRelatedPerson`,
  coverage: `${UNIFY_PROFILE_BASE}/UnifyCoverage`,
  documentReference: `${UNIFY_PROFILE_BASE}/UnifyDocumentReference`,
  communication: `${UNIFY_PROFILE_BASE}/UnifyCommunication`,
  communicationRequest: `${UNIFY_PROFILE_BASE}/UnifyCommunicationRequest`,
  healthcareService: `${UNIFY_PROFILE_BASE}/UnifyHealthcareService`,
  locationSite: `${UNIFY_PROFILE_BASE}/UnifyLocationSite`,
  locationRoom: `${UNIFY_PROFILE_BASE}/UnifyLocationRoom`,
  schedule: `${UNIFY_PROFILE_BASE}/UnifySchedule`,
  encounter: `${UNIFY_PROFILE_BASE}/UnifyEncounter`,

  // P2
  organization: `${UNIFY_PROFILE_BASE}/UnifyOrganization`,
  practitionerRole: `${UNIFY_PROFILE_BASE}/UnifyPractitionerRole`,
  careTeam: `${UNIFY_PROFILE_BASE}/UnifyCareTeam`,
  account: `${UNIFY_PROFILE_BASE}/UnifyAccount`,
  observation: `${UNIFY_PROFILE_BASE}/UnifyObservation`,
  device: `${UNIFY_PROFILE_BASE}/UnifyDevice`,
  group: `${UNIFY_PROFILE_BASE}/UnifyGroup`,
  questionnaire: `${UNIFY_PROFILE_BASE}/UnifyQuestionnaire`,
  activityDefinition: `${UNIFY_PROFILE_BASE}/UnifyActivityDefinition`,
  planDefinition: `${UNIFY_PROFILE_BASE}/UnifyPlanDefinition`,
  chargeItem: `${UNIFY_PROFILE_BASE}/UnifyChargeItem`,
  chargeItemDefinition: `${UNIFY_PROFILE_BASE}/UnifyChargeItemDefinition`,
  claim: `${UNIFY_PROFILE_BASE}/UnifyClaim`,
  coverageEligibilityRequest: `${UNIFY_PROFILE_BASE}/UnifyCoverageEligibilityRequest`,
  coverageEligibilityResponse: `${UNIFY_PROFILE_BASE}/UnifyCoverageEligibilityResponse`,
  provenance: `${UNIFY_PROFILE_BASE}/UnifyProvenance`,
  carePlan: `${UNIFY_PROFILE_BASE}/UnifyCarePlan`,
  goal: `${UNIFY_PROFILE_BASE}/UnifyGoal`,
} as const;

export type UnifyProfileUrl = (typeof UNIFY_PROFILES)[keyof typeof UNIFY_PROFILES];
